import { useEffect, useState } from "react";
import api from "@/lib/api";

function sessionId() {
  let id = localStorage.getItem("sb_sid");
  if (!id) {
    id = crypto.randomUUID ? crypto.randomUUID() : String(Math.random()).slice(2);
    localStorage.setItem("sb_sid", id);
  }
  return id;
}

export default function VisitorCounter() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const sid = sessionId();
    let alive = true;
    const beat = async () => {
      try {
        const r = await api.post("/heartbeat", {}, { headers: { "X-Session-Id": sid } });
        if (alive) setCount(r.data?.online || 0);
      } catch (err) {
        console.warn("[heartbeat] failed:", err?.message);
      }
    };
    beat();
    const t = setInterval(beat, 30_000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  if (!count) return null;

  return (
    <div
      data-testid="visitor-counter"
      className="inline-flex items-center gap-2 px-2.5 py-1 rounded-full font-mono text-[10px]"
      style={{
        border: "1px solid var(--sb-border)",
        background: "var(--sb-surface)",
        color: "var(--sb-text-secondary)",
      }}
    >
      <span className="wc-live-dot" />
      <span>
        <strong style={{ color: "var(--sb-primary)" }}>{count}</strong> ONLINE NOW
      </span>
    </div>
  );
}
